import {ACTION_CODE} from './_actionCode';
import {ServicesService} from '../../services';
import {ErrorModel, ResultModel} from '../../models';
import {LoggerService} from '../../services';

const FUNCTION_CODE = 'UPDATE_SERVICE';

export async function updateService(token = '', projectId: number | string, payload: Record<string, unknown>) {
    try {
        LoggerService.logInfo('Action - updateService - Start');

        const result = await ServicesService.updateService(token, projectId, payload);

        LoggerService.logInfo('Action - updateService - End - Success');

        return ResultModel.newSuccessResult(result);
    }
    catch (error) {
        LoggerService.logInfo('Action - updateService - End - Error');

        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la mise à jour du service',
            error: error
        });
        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
